module.exports = __webpack_public_path__ + "static/img/money55.6093fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/money55.png
// module id = 6I+R
// module chunks = 73